import React from 'react'

import {GetStaticProps} from 'next/types'

import SEO from 'components/elements/SEO'
import TemplateFaq from 'components/templates/TemplateFaq'
import sanityClient from 'src/backend/lib/sanityClient'
import {TPageComponent} from 'src/types'
import {FaqPage} from 'src/types/__sanitySchema__'
import {getKeywords} from 'src/utils'

interface IFaqProps {
	pageContent: FaqPage
}

const Faq: TPageComponent<IFaqProps> = ({pageContent}) => {
	return (
		<>
			<SEO
				title={pageContent?.seo?.seo_title || pageContent?.title}
				description={pageContent?.seo?.meta_description}
				keywords={getKeywords(pageContent?.seo?.focus_keyword, pageContent?.seo?.focus_synonyms)}
			/>
			<TemplateFaq pageContent={pageContent} />
		</>
	)
}

export const getStaticProps: GetStaticProps<IFaqProps> = async () => {
	try {
		const faqContent = (await sanityClient.fetch<FaqPage[]>('*[_type == "faqPage"]'))[0]
		return {
			props: {
				pageContent: faqContent,
			},
		}
	} catch {
		return {
			notFound: true,
		}
	}
}

Faq.displayName = 'Faq'

export default Faq
